import { IQuickBookCustomer } from '../../model/api/customers/quickbook-customer';

import { getApi } from './api';
import { AxiosResponse } from 'axios';
import {IQuickBookProduct} from '../../model/api/customers/customer-quickbook-settings';
import {IQuickBookInvoice} from "../../model/api/customers/customer-quikcbook-invoices";
import {IBillingClass} from "../../model/api/customers/billing-class";
import {IBillingDepartment} from "../../model/api/customers/billing-department";
import {IBillingTerm} from "../../model/api/customers/billing-term";

const URL = '/billing/external';

const getCustomerList = async (): Promise<Array<IQuickBookCustomer>> => {
  const api = await getApi();

  return api.get<Array<IQuickBookCustomer>>(`${URL}/customers`).then((response: AxiosResponse<Array<IQuickBookCustomer>>) => response.data);
};

export const getProductList = async (): Promise<Array<IQuickBookProduct>> => {
  const api = await getApi();
  return api.get<Array<IQuickBookProduct>>(`${URL}/products`).then((response: AxiosResponse<Array<IQuickBookProduct>>) => response.data);
};

export const getInvoiceList = async (): Promise<Array<IQuickBookInvoice>> => {
  const api = await getApi();
  return api.get<Array<IQuickBookInvoice>>(`${URL}/invoices`).then((response: AxiosResponse<Array<IQuickBookInvoice>>) => response.data);
};

const getBillingClasses = async (): Promise<Array<IBillingClass>> => {
  const url = `${URL}/classes`;
  const api = await getApi();
  return api.get<Array<IBillingClass>>(url).then((response: AxiosResponse<Array<IBillingClass>>) => {
    return response.data;
  });
};

const getBillingDepartments = async (): Promise<Array<IBillingDepartment>> => {
  const url = `${URL}/departments`;
  const api = await getApi();
  return api.get<Array<IBillingDepartment>>(url).then((response: AxiosResponse<Array<IBillingDepartment>>) => {
    return response.data;
  });
};

const getBillingTerms = async (): Promise<Array<IBillingTerm>> => {
  const url = `${URL}/salesterms`;
  const api = await getApi();
  return api.get<Array<IBillingTerm>>(url).then((response: AxiosResponse<Array<IBillingTerm>>) => {
    return response.data;
  });
};

export const quickBookExternalService = {
  getCustomerList,
  getProductList,
  getInvoiceList,
  getBillingClasses,
  getBillingDepartments,
  getBillingTerms,
};
